export default __webpack_public_path__ + "static/media/apple.95b2a155.svg";